import { render, staticRenderFns } from "./web-cam.vue?vue&type=template&id=da9ff206&scoped=true&"
import script from "./web-cam.vue?vue&type=script&lang=js&"
export * from "./web-cam.vue?vue&type=script&lang=js&"
import style0 from "./web-cam.vue?vue&type=style&index=0&id=da9ff206&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da9ff206",
  null
  
)

export default component.exports